'use strict';

var React = require('react');

var SvgEyeCheckMarkIcon = function SvgEyeCheckMarkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.779 9.165c-.221.453-.279.753-.279.835 0 .082.058.382.279.835.21.427.533.925.983 1.398.89.937 2.264 1.767 4.238 1.767.414 0 .75.336.75.75s-.336.75-.75.75c-2.444 0-4.196-1.045-5.325-2.233-.561-.59-.971-1.216-1.243-1.773-.26-.532-.432-1.076-.432-1.494 0-.418.171-.962.432-1.494.272-.556.682-1.183 1.243-1.773 1.13-1.188 2.88-2.233 5.325-2.233 2.432 0 4.12.972 5.224 2.1 1.083 1.107 1.6 2.355 1.754 2.968.1.402-.144.81-.546.91-.402.1-.81-.144-.91-.546-.096-.387-.495-1.389-1.37-2.282-.853-.872-2.166-1.65-4.152-1.65-1.974 0-3.348.83-4.238 1.767-.45.472-.774.971-.983 1.398Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 13c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3Zm0-1.5c.828 0 1.5-.672 1.5-1.5s-.672-1.5-1.5-1.5-1.5.672-1.5 1.5.672 1.5 1.5 1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.53 13.28c.293-.293.293-.767 0-1.06-.293-.293-.767-.293-1.06 0l-2.47 2.47-.97-.97c-.293-.293-.767-.293-1.06 0-.293.293-.293.767 0 1.06l1.5 1.5c.293.293.767.293 1.06 0l3-3Z"
  }));
};
SvgEyeCheckMarkIcon.displayName = "EyeCheckMarkIcon";

exports.SvgEyeCheckMarkIcon = SvgEyeCheckMarkIcon;
